/**
 * @file Status dot components.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  status: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'success-vibrant',
    'info',
    'warning',
    'note',
    'danger',
    'gray',
    'gray-dark',
    'yellow',
    'white',
    'purple',
    'dark-transparent',
    'orange',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  className: PropTypes.string,
};

const defaultProps = {
  status: 'primary',
  size: 'sm',
};

const StatusDot = ({ status, size, className }) => {
  const classes = classNames({
    'status-dot': true,
    [`status-dot-${status}`]: true,
    [`status-dot-${size}`]: !!size,
    [className]: !!className,
  });

  return <span className={classes} />;
};

StatusDot.propTypes = propTypes;
StatusDot.defaultProps = defaultProps;

export default StatusDot;
